import { HttpRequest } from '@angular/common/http';

export const showLoadingHelper = (req: HttpRequest<any>) => {

  if (window.location.pathname.includes('administration') && req.url.includes('?sort')) {
    return true;
  }

  if (req.url.includes('?sort')) {
    return false;
  }

  if (
    req.url.includes('/lov') ||
    req.url.includes('/quick-search') ||
    req.url.includes('/project/jira') ||
    req.url.includes('/project/template') ||
    req.url.includes('/order/autocomplete') ||
    req.url.includes('/budget/autocomplete') ||
    req.url.includes('/users/jira/autocomplete') ||
    req.url.includes('/user/workspace')
  ) {
    return false;
  }
  if (req.url.includes('/batch/') && (req.method == 'PUT' || req.method == 'OPTIONS')) {
    return false;
  }
  return true;
};
